'use client';

import { GrossMarginValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: GrossMarginValues;
  onValuesChange: (field: keyof GrossMarginValues, value: number) => void;
  translations: ToolsTranslations['grossMargin'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof GrossMarginValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.grossProfit}</label>
        <input type="text" value={values.grossProfit.toLocaleString('sv-SE')} onChange={handleChange('grossProfit')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.sales}</label>
        <input type="text" value={values.sales.toLocaleString('sv-SE')} onChange={handleChange('sales')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


